<template>
<!-- 流量相关的审核 和 查看页 -->
<div class="flow_check_scan" v-loading="loading">
  <div class="flow_check_title">订单信息</div>
  <div class="info_list">
    <div class="info_item">
      <div class="info_item_label">订单编号</div>
      <div class="info_item_content">{{infos.order_no}}</div>
    </div>
    <div class="info_item">
      <div class="info_item_label">下单用户</div>
      <div class="info_item_content">{{infos.cust_name}}</div>
    </div>
    <div class="info_item">
      <div class="info_item_label">服务内容</div>
      <div class="info_item_content">{{fwnr}}</div>
    </div>
    <div class="info_item">
      <div class="info_item_label">支付方式</div>
      <div class="info_item_content">{{infos.pay_type * 1 === 1 ? '支付宝' : '线下转账'}}</div>
    </div>
    <div class="info_item">
      <div class="info_item_label">购买数量</div>
      <div class="info_item_content">{{infos.buy_amount}}</div>
    </div>
    <div class="info_item">
      <div class="info_item_label">订单金额</div>
      <div class="info_item_content">{{infos.pay_price}}</div>
    </div>
    <div class="info_item">
      <div class="info_item_label">下单时间</div>
      <div class="info_item_content">{{infos.create_time}}</div>
    </div>
    <div class="info_item info_item_require" v-if="pageType === 'flowcheck'">
      <div class="info_item_label">转账凭证</div>
      <div class="info_item_content">
        <yjh-upload
          :url="baseAPI + '/invoice/do_add'"
          :stopUpload="true"
          :max="10"
          :fileType="['JPG', 'JPEG', 'PNG', 'BMP']"
          overSizeToast="上传文件大小不能超过10M"
          @beforeUpload="handleUpload"
        ></yjh-upload>
      </div>
    </div>
    <p class="check-vip__tips" v-if="pageType === 'flowcheck'">文件格式支持图片文件(.JPG/.JPEG/.PNG/.BMP)</p>
    <div class="info_item info_item_img" v-if="pageType === 'flowscan'">
      <div class="info_item_label">转账凭证</div>
      <img :src="file" alt="" @click="showFullImg=true">
    </div>
  </div>
  <div class="opes">
    <Button type="primary" @click.stop="gotoList" :disabled="subDisabled">{{ pageType === 'flowcheck' ? '通过' : '返回列表' }}</Button>
  </div>
  <full-diag :isShow="showFullImg" @close="toggleFullImg(false)">
    <div class="full-img-content">
      <img :src="file" alt="">
    </div>
  </full-diag>
</div>
</template>
<script>
import yjhUpload from '@/components/yjhUpload'
import { liuliangDetail, liuliangCheck } from '@/api/flow'
import fullDiag from '@/components/dialogs/fullDiag'
export default {
  name: 'flowCheckScan',
  components: { yjhUpload, fullDiag },
  data() {
    return {
      file: '',
      infos: {},
      loading: false,
      subDisabled: false,
      showFullImg: false,
      returnUrl: null
    }
  },
  computed: {
    pageType() { // flowcheck: 审核 flowscan: 查看
      return this.$route.name
    },
    fromPage() { // 来源 member: 会员流水 live: 直播 meeting: 会议室 diaoyan: 调研
      return this.$route.params.type
    },
    id() { // 每条记录的单独id
      return this.$route.params.id
    },
    baseAPI() {
      return process.env.VUE_APP_BASE_API
    },
    fwnr() {
      return { 'live': '直播数', 'meeting': '会议室', 'diaoyan': '可用次数' }[this.fromPage]
    }
  },
  mounted() {
    this.returnUrl = `/flow/${this.fromPage}/outline`
    this.$store.commit('SET_RETURN_TITLE', this.pageType === 'flowcheck' ? '审核' : '查看')
    this.$store.commit('SET_RETURN_URL', this.returnUrl)
    this.$store.commit('SET_RETURN_TYPE', 'small')
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      liuliangDetail(
        this.fromPage,
        { order_no: this.$route.params.id }
      ).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.infos = res.result
          this.file = res.result.evidence_pic
        }
      })
    },
    gotoList() { // 点击事件
      if (this.pageType === 'flowcheck') {
        if (!this.file) {
          this.$Message.info('请上传转账凭证')
          return
        }
        const _this = this
        _this.subDisabled = true
        setTimeout(() => {
          var formData = new FormData()
          formData.append('order_no', _this.id)
          formData.append('file', _this.file)
          liuliangCheck(this.fromPage, formData).then(res => {
            if (res.code === 0) {
              this.$router.push(this.returnUrl)
            } else {
              _this.$Message.info(res.msg)
              _this.subDisabled = false
            }
          })
        }, 1000)
      } else if (this.pageType === 'flowscan') {
        this.$router.push(this.returnUrl)
      }
    },
    handleUpload(file) {
      this.file = file
    },
    toggleFullImg(flag) {
      this.showFullImg = flag
    }
  }
}
</script>
<style lang="scss" scoped>
.flow_check_scan {
  padding: 10px 120px;
  .flow_check_title {
    font-size: 14px;
    // border-bottom: 1px solid #D9E2EF;
    color: #5d6f80;
    margin-bottom: 24px;
  }
  .info_list {
    padding-bottom: 18px;
    .info_item {
      display: flex;
      align-items: center;
      margin-bottom: 21px;
      .info_item_label {
        width: 120px;
        text-align: right;
        margin-right: 20px;
        &:after {
          content: ':'
        }
      }
      img {
        width: 210px;
        height: 130px;
      }
    }
    .info_item_require {
      .info_item_label {
        position: relative;
        &:after {
            display: inline-block;
            content: '*';
            position: absolute;
            left: 60px;
            top: 0px;
            font-size: 18px;
            color: red;
        }
      }
    }
    .info_item_img {
      align-items: flex-start;
    }
  }
  .opes {
    display: flex; justify-content: center;
  }
  /deep/ .link-btn {
    position: relative;
    left: 10px;
    top: -10px;
  }
}
.check-vip__tips {
  margin-top: -8px;
  margin-left: 140px;
  color:#9B9EA0;
}
</style>
